import EPage from '@/enums/EPages';
import EBasicActions from '@/enums/EBasicActions';
import PageActions from '@/interfaces/PageActions';

/**
 * Checks a page/action pair against the staff actions `useAuth` persists in localStorage
 * at login, for code that runs outside React (no `usePermissions` hook available).
 */
const hasStoredAccess = (page: EPage, action: EBasicActions): boolean => {
  const storedActions: PageActions | null = JSON.parse(localStorage.getItem('actions') ?? 'null');
  return !!storedActions?.[page]?.includes(action);
};

export default hasStoredAccess;
